
import { mapState, mapActions, mapMutations } from 'vuex'

import SiteHeader from '@pleinair/bigcolony-vue/components/_globals/layout/header/SiteHeader.vue'
import SiteFooter from '@pleinair/bigcolony-vue/components/_globals/layout/SiteFooter.vue'
import Errors from '@pleinair/bigcolony-vue/components/_globals/layout/Errors.vue'
import SiteOverlay from '@pleinair/bigcolony-vue/components/_globals/layout/SiteOverlay.vue'
import SitePopup from '@pleinair/bigcolony-vue/components/_globals/layout/SitePopup.vue'
import Cart from '@pleinair/bigcolony-vue/components/common/Cart/index.vue'

export default {
  name: 'CommonLayoutContainer',
  components: {
    SiteHeader,
    SiteFooter,
    Errors,
    Cart,
    SiteOverlay,
    SitePopup,
  },
  props: {
    webview: Boolean,
    mainMenu: Array,
    mainNavConfig: Object,
    mobileMenu: Array,
    mobileMenuConfig: Object,
    footerMenu: Object,
    logos: Object,
    locationIcon: Object,
    chevron: Object,
    rewardsTrophy: Object,
    cartConfig: Object,
    siteOverlayConfig: Object,
    tokenConfig: Object,
  },
  computed: {
    ...mapState([ 'location', 'loading', 'errors', 'token', 'user', 'cart', 'product', 'category' ]),
    ...mapState({
      rewards: state => state.members.rewards,
    }),
    pagePath() {
      return this.$route.path.replace(/\//g, '_').replace(/_$/, '')
    },
    hasErrors() {
      if (this.errors) {
        if (Array.isArray(this.errors) && this.errors?.length > 0 ) {
          return true
        } else if (typeof this.errors === 'string') {
          return true
        } else if (typeof this.errors === 'object' && this.errors.message) {
          return true
        }
      }
      return false
    },
    tokenVersion() {
      return process.env.TOKEN_VERSION
    },
    webViewClass() {
      const pagePath = this.pagePath ? `page_${this.pagePath}` : '';
      return `${this.webview ? 'app' : 'web'}-layout ${pagePath}`
    },
    routeName() {
      if (this.$route.name === 'menu-mid' && this.location?.name) {
        return `Menu page: ${this.location.name}`
      }
      if (this.$route.name === 'menu-mid-product-pid' && this.product?.data?.name) {
        return `Product page: ${this.product.data.name}`
      }

      if (this.$route.name === 'menu-mid-category-cid' && this.category?.name) {
        return `Category page: ${this.category.name}`
      }
      const pathTitle = this.$route.path.split('/').filter(Boolean)
      return ['Page', ...(pathTitle.length > 0 ? pathTitle : ['home'])].join(' ')
    },
  },
  methods: {
    ...mapMutations([ 'setToken', 'setUser', 'setCart', 'setLocation', 'setMenu', 'setErrors', 'setAppState' ]),
    ...mapActions([ 'getUser', 'getCart', 'abandonCart', 'reloadLocation', 'transferCart', 'sendRequest', 'logoutUser' ]),
    ...mapActions({
      getRewards: 'members/getRewards',
    }),
  },
  async beforeMount() {
    console.log("🚀 ~ beforeMount ~ this.webview:", this.webview)
    if (this.webview) {
      // dump App Data
      this.setToken(null)
      this.setUser(null)
      this.setCart(null)
      this.setAppState(null)
      this.setLocation(null)
      console.log('*** dumpAppData happens on AppContainer.vue')
    } else {

      if (this.$route?.query?.store === 'clear') {
        this.setLocation(null)
        this.setMenu(null)
        await this.abandonCart()
      }
  
      if (this.token && !this.user) {
        await this.getUser()
      }
      if (this.cart) {
        await this.getCart()
      }
  
      // Do not reload the location data if it is a menu page
      const isMenu = this.$route.path.includes('/menu')
      if (isMenu) {
        return
      }
  
      // Reload the location data - mainly the open/closed status
      console.log("🚀 ~ beforeMount ~ this.location:", this.location)
      console.log("🚀 ~ beforeMount ~ this.cart:", this.cart)
      if (this.location || this.cart) {
        const menuId = this.cart && this.cart.menu_id ? this.cart.menu_id : this.location.menu_id
        await this.reloadLocation(menuId)
  
        // Transfer cart if the menus are still different for some reason
        if (this.location?.services?.transfercart && this.cart?.menu_id !== this.location?.menu_id) {
          console.log("🚀 ~ beforeMount ~ transferCart happens")
          this.transferCart(menuId)
        }
      }
    }
  },
  watch: {
    async $route() {
      if (
        this.token &&
        (!this.token.provider || !this.token.provider.includes('spendgo') || !this.token.version || this.token.version < this.tokenVersion)
      ) {
        await this.logoutUser()
      }
    },
  },
}
